import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Icon from '../../atoms/icons/Icon';
import Span from '../../atoms/spans/Span';

/**
 * ES6 stateless component
 * @param {object} props - React props object (className, children, intl, onClick function).
 */
const Button = (props) => {
  return (
    <button
      id={props.id}
      data-testid={props.id}
      className={props.className}
      type={props.type}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
      {props.iconClassName && <Icon className={props.iconClassName} />}
      <Span className={'label'}>
        {props.intl.messages[props.label] || props.label}
      </Span>
    </button>
  );
};

Button.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  intl: PropTypes.object,
};

export default injectIntl(Button);
